import { useState } from 'react'
import styled from 'styled-components'

import { Popup, Text, Dropdown } from 'components'
import useLanguage from 'hooks/use-language'

interface IProps {
  visible: boolean
  onClose: () => void
}

const ChangeLanguageModal = ({ onClose, visible }: IProps) => {
  const { language, languageOptions, updateLanguage } = useLanguage()

  const [selected, setSelected] = useState(language)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async () => {
    setIsSubmitting(true)
    const response = await updateLanguage(selected)
    setIsSubmitting(false)

    if (response.isSuccess) {
      onClose()
    }
  }

  if (!visible) return <></>

  return (
    <Popup
      minWidth="650px"
      minHeight="325px"
      width="700px"
      labelPrimary="btn_confirm"
      labelSecondary="cancel_btn"
      onClickSecondary={onClose}
      onClickPrimary={handleSubmit}
      isSubmitting={isSubmitting}
    >
      <Container>
        <Text fontSize={25} fontWeight="bold" mb={18}>
          languages
        </Text>
        <Text mb={23}>update_language_confirm_info</Text>
        <Dropdown
          name="language"
          placeholder="select_language_plc"
          width={200}
          isSearchable={false}
          options={languageOptions}
          value={languageOptions.find((item) => item.value === selected)}
          onChange={(item) => setSelected(item.value)}
        />
      </Container>
    </Popup>
  )
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding-top: 60px;
`

export default ChangeLanguageModal
